import { Text } from '@antimatterhq/ui/components/typography';
import { Icon } from '@iconify/react/dist/iconify.js';
import Spacer from '@antimatterhq/ui/components/spacer';
import {
  SimpleTableCell,
  SimpleTableRow,
} from '@antimatterhq/ui/components/simpleTable';

export type EmptyTableProps = {
  message?: string;
  cols?: number;
};

export const EmptyTable = ({
  message = 'no results found',
  cols = 1,
}: EmptyTableProps) => {
  return (
    <SimpleTableRow border={false} hover={false}>
      <SimpleTableCell className="h-[175px]" colSpan={cols}>
        <div className="flex flex-col items-center justify-center">
          <Icon
            icon="lucide:list"
            width={100}
            className="text-grey-500 dark:text-grey-400"
          />
          <Spacer size="base" />
          <div>
            <Text color="info">{message}</Text>
          </div>
        </div>
      </SimpleTableCell>
    </SimpleTableRow>
  );
};
